import {
  automationPath,
  channelsPath,
  integrationsPath,
} from "@/utils/accountRoutes";

/**
 * Labels and destinations for the onboarding checklist.
 *
 * Two rules, both learned the hard way:
 *
 * 1. **A label may not claim more than `onboardingService` verifies.** The
 *    `channel` step completes on any active `Channel` row — WhatsApp, Instagram,
 *    Telegram, e-mail, TikTok or webchat — so calling it "Conectar o WhatsApp"
 *    turned a generic check into a specific, and sometimes false, assertion: the
 *    home told an account with no WhatsApp that its WhatsApp was connected. The
 *    `flow` step likewise only checks that a flow *exists*; nothing about it is
 *    published. The service's own labels are "Canal" and "Fluxo" for a reason.
 * 2. **Every destination is account-scoped.** There is no account-less
 *    `/internal/integrations` — the catch-all route swallows it and bounces to
 *    `/internal/dashboard`, which is exactly what "the button does nothing"
 *    looks like from the outside.
 */
export function buildStepConfig(accountId) {
  return {
    integrations: {
      label: "Conectar uma integração",
      path: integrationsPath(accountId),
    },
    flow: { label: "Criar o primeiro fluxo", path: automationPath(accountId) },
    channel: {
      label: "Conectar um canal de atendimento",
      path: channelsPath(accountId),
    },
  };
}

export default buildStepConfig;
